import React from 'react';
import TableCell from '@material-ui/core/TableCell';
import { FFTableCellProps } from './types';
import { useFFTableStyles } from './styles';
import { MDButton } from '../MDButton';

export function FFTableCell<T>({
  column,
  row,
  value,
  onActionClick,
}: FFTableCellProps<T>) {
  const classes = useFFTableStyles();

  const renderCellContent = () => {
    // If a custom renderer is provided, use it
    if (column.renderCell) {
      return column.renderCell(value, row);
    }

    // Otherwise, render based on column type
    switch (column.type) {
      case 'action':
        return (
          <MDButton
            variant="gradient"
            color="info"
            size="small"
            className={classes.actionButton}
            disabled={column.shouldDisableCta ? column.shouldDisableCta(row) : false}
            onClick={() => {
              if (onActionClick) {
                const id = (row as any).id;
                onActionClick(id, String(column.id));
              }
            }}
          >
            {column.label}
          </MDButton>
        );
      case 'date':
        if (value instanceof Date) {
          return column.dateFormat ? column.dateFormat(value) : value.toLocaleDateString();
        }
        if (typeof value === 'string') {
          const date = new Date(value);
          return column.dateFormat ? column.dateFormat(date) : date.toLocaleDateString();
        }
        return value;
      case 'number':
        if (typeof value === 'number') {
          return value.toLocaleString();
        }
        return value;
      case 'boolean':
        return value ? 'Yes' : 'No';
      default:
        return value;
    }
  };

  return (
    <TableCell
      align={column.align || 'left'}
      style={{ 
        minWidth: column.minWidth, 
        width: column.width,
      }}
      className={classes.tableCell}
    >
      {renderCellContent()}
    </TableCell>
  );
}

export default FFTableCell;
